module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat-locked-398dae8fe67af00ab81603f90b61e329.svg";